import { render, staticRenderFns } from "./authorizationSuccess.vue?vue&type=template&id=0be24546&scoped=true&"
import script from "./authorizationSuccess.vue?vue&type=script&lang=js&"
export * from "./authorizationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./authorizationSuccess.vue?vue&type=style&index=0&id=0be24546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be24546",
  null
  
)

export default component.exports